export const SET_ROOM_INFO = "SET_ROOM_INFO";
export const SET_FOUND_ROOM = "SET_FOUND_ROOM";
